// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "hr.separator.block[data-v-0f695b9b]{margin:1rem 0}.separator[data-v-0f695b9b]{--color:var(--shade-200,#ebedf0)}.separator.block[data-v-0f695b9b]{background-color:var(--color);height:1px;margin:.5rem 0}.separator.inline[data-v-0f695b9b]{background-color:var(--color);height:1.6rem;margin:.5rem 1rem;width:1px!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
